import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { getDocumentTypeLabel } from '../helpers/document-type-label.helper';

/**
 * Shows a backend document (type) name in the active language when it is a known type,
 * otherwise shows the raw name. Display only - keep comparisons and payloads on the raw name.
 * Impure (like the transloco pipe) so the label follows a live language switch.
 */
@Pipe({
  name: 'documentTypeLabel',
  standalone: true,
  pure: false
})
export class DocumentTypeLabelPipe implements PipeTransform {
  private readonly transloco = inject(TranslocoService);

  transform(name: string | null | undefined): string {
    return getDocumentTypeLabel(this.transloco, name);
  }
}